import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Icon } from '../ui/Icon';

interface UnitReviewNoticeProps {
  count: number;
}

const Notice = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-xs) var(--space-sm);
  margin: var(--space-sm) 0;
  padding: var(--space-sm) var(--space-md);
  border: 1px solid var(--warning-500);
  border-radius: 8px;
  background: var(--warning-100);
  color: var(--text-primary);
  font-size: var(--font-size-sm);
`;

const ReviewLink = styled(Link)`
  color: var(--text-primary);
  font-weight: var(--font-weight-semibold);
  text-decoration: underline;
`;

export function UnitReviewNotice({ count }: UnitReviewNoticeProps) {
  if (count <= 0) return null;

  const label =
    count === 1
      ? '1 registro no se incluye en los totales porque su unidad no es válida.'
      : `${count} registros no se incluyen en los totales porque su unidad no es válida.`;

  return (
    <Notice role="status">
      <Icon name="warning" size="sm" color="var(--warning-600)" aria-hidden />
      <span>{label}</span>
      <ReviewLink to="/transactions">Revisar unidades</ReviewLink>
    </Notice>
  );
}
